import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Components/Images/Zartec Logo_page-0001.jpg';
 // Add a white version of your logo
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import LogoWhite from '../Components/Images/logo10.png'

function Headerclaude() {
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [isTransparent, setIsTransparent] = useState(true);
  const dropdownRef = useRef(null);
  const headerRef = useRef(null);

  // Handle scroll to change navbar style
  useEffect(() => {
    const handleScroll = () => {
      // Adjust the scroll threshold as needed (e.g., after hero section)
      const scrollThreshold = window.innerHeight * 0.7; // 70% of viewport height
      
      if (window.scrollY > scrollThreshold) {
        setIsTransparent(false);
      } else {
        setIsTransparent(true);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMegaMenu(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to close the mega menu
  const handleLinkClick = () => {
    setShowMegaMenu(false);
  };

  return (
    <header 
      ref={headerRef}
      className={`fixed-top navbar-wrapper ${isTransparent ? 'navbar-transparent' : 'navbar-solid'}`}
      style={{
        transition: 'background-color 0.3s ease, box-shadow 0.3s ease'
      }}
    >
      {/* Top Banner (Optional - you can remove if not needed) */}
      <a 
        className="section section-banner d-none d-xl-block" 
        href="#"
        style={{
          backgroundImage: 'url(assets/images/banner/background-04-1920x60.jpg)',
          backgroundImage: '-webkit-image-set(url(assets/images/banner/background-04-1920x60.jpg) 1x, url(assets/images/banner/background-04-3840x120.jpg) 2x'
        }}
      >
        <img 
          src="assets/images/banner/foreground-04-1600x60.png" 
          srcSet="assets/images/banner/foreground-04-1600x60.png 1x, assets/images/banner/foreground-04-3200x120.png 2x" 
          alt="" 
          width="1600" 
          height="310"
        />
      </a>
        
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <img 
              src={isTransparent ? LogoWhite : Logo} 
              alt="Sensetech Trading LLC Logo" 
              width="200" 
              height="40"
            />
          </Link>

          {/* Mobile Toggle Button */}
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarContent"
            aria-controls="navbarContent" 
            aria-expanded="false" 
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Content */}
          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link 
                  className={`nav-link ${isTransparent ? 'text-white' : 'text-dark'}`} 
                  to="/"
                >
                  Home
                </Link>
              </li>

              {/* Products Dropdown */}
              <li 
                className="nav-item dropdown" 
                ref={dropdownRef}
              >
                <a 
                  className={`nav-link dropdown-toggle ${isTransparent ? 'text-white' : 'text-dark'}`}
                  href="#" 
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                >
                  Products
                </a>
                <ul 
                  className={`dropdown-menu ${isTransparent ? 'dropdown-menu-dark' : ''}`}
                  style={{
                    backgroundColor: isTransparent ? 'rgba(0,0,0,0.8)' : '#fff',
                    border: 'none',
                    boxShadow: '0 6px 12px rgba(0,0,0,0.1)'
                  }}
                >
                  <div className="container">
                    <div className="row">
                      {/* Industrial Division */}
                      <div className="col-md-6">
                        <h6 
                          className="dropdown-header" 
                          style={{ 
                            color: isTransparent ? '#fff' : '#00663b',
                            borderBottom: `3px solid ${isTransparent ? '#fff' : '#00663b'}` 
                          }}
                        >
                          Industrial Division
                        </h6>
                        <div className="row">
                          <div className="col-md-12">
                            <Link 
                              to="/cij" 
                              className={`dropdown-item ${isTransparent ? 'text-white' : 'text-dark'}`}
                              onClick={handleLinkClick}
                            >
                              Continuous Inkjet Printers (CIJ)
                            </Link>
                            <Link 
                              to="/tij" 
                              className={`dropdown-item ${isTransparent ? 'text-white' : 'text-dark'}`}
                              onClick={handleLinkClick}
                            >
                              Thermal Inkjet Printer (TIJ)
                            </Link>
                            <Link 
                              to="/laser" 
                              className={`dropdown-item ${isTransparent ? 'text-white' : 'text-dark'}`}
                              onClick={handleLinkClick}
                            >
                              Laser Printers
                            </Link>
                            {/* Add other industrial products */}
                          </div>
                        </div>
                      </div>

                      {/* Retail Division */}
                      <div className="col-md-6">
                        <h6 
                          className="dropdown-header" 
                          style={{ 
                            color: isTransparent ? '#fff' : '#01557a',
                            borderBottom: `3px solid ${isTransparent ? '#fff' : '#01557a'}` 
                          }}
                        >
                          Retail Division
                        </h6>
                        <div className="row">
                          <div className="col-md-12">
                            <Link 
                              to="/eas-system" 
                              className={`dropdown-item ${isTransparent ? 'text-white' : 'text-dark'}`}
                              onClick={handleLinkClick}
                            >
                              EAS System
                            </Link>
                            <Link 
                              to="/retail-scales" 
                              className={`dropdown-item ${isTransparent ? 'text-white' : 'text-dark'}`}
                              onClick={handleLinkClick}
                            >
                              Retail Weighing Scales
                            </Link>
                            {/* Add other retail products */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </li>

              {/* Other Navigation Items */}
              <li className="nav-item">
                <Link 
                  className={`nav-link ${isTransparent ? 'text-white' : 'text-dark'}`} 
                  to="/services"
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className={`nav-link ${isTransparent ? 'text-white' : 'text-dark'}`} 
                  to="/about-us"
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className={`nav-link ${isTransparent ? 'text-white' : 'text-dark'}`} 
                  to="/contact-us"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Optional: Add custom CSS for additional styling */}
      <style jsx="true">{`
        /* Transparent Navbar Styles */
        .navbar-transparent {
          background-color: transparent !important;
          position: absolute;
          width: 100%;
          z-index: 1030;
        }

        .navbar-transparent .navbar-nav .nav-link {
          color: white !important;
        }

        /* Solid Navbar Styles */
        .navbar-solid {
          background-color: white !important;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .navbar-solid .navbar-nav .nav-link {
          color: #333 !important;
        }

        /* Dropdown Styles */
        .dropdown-menu {
          margin-top: 0.5rem;
        }
      `}</style>
    </header>
  );
}

export default Headerclaude;